import React from "react";
import { DivImpressoras } from './style';

import Zebra from '../img/img_Imp_Zebra2.png';
import Datamax from '../img/img_Imp_Datamax2.png';
import Argox from '../img/img_Imp_Argox2.png';
import Logo from '../img/img_logoEPC_medio.png';
import Elgin from '../img/img_Imp_Elgin2.png';

export const Impressoras = () => {

    return (
        <DivImpressoras>

            <div className="conteudo">

                <div className="coluna-esquerda">
                    <h1>Impressoras</h1>
                    <p>Trabalhamos com a venda e assistência<br />técnica das seguintes marcas de impressoras:</p>

                    <div className="marcas">
                        <img src={Elgin} alt="impressora elgin" />
                        <img src={Zebra} alt="impressora zebra" />
                        <img src={Datamax} alt="impressora datamax" />
                        <img src={Argox} alt="impressora argox" />
                    </div>
                </div>

                <div className="logo-canto">
                    <img src={Logo} alt="logo etiquetapontocom" />
                </div>

                <div className="linha-final">
                    <span className="quadrado"></span>
                </div>

            </div>

        </DivImpressoras>
    )
}
